import { AnnotationGroup } from '@/utils/entities';
import { cn } from '@/utils/classname';
import { useEffect, useRef } from 'react';

export interface AnnotationGroupNodeProps {
  group: AnnotationGroup;
  isChecked: boolean;
  handleChange: () => void;
  isIndeterminate: boolean;
}

export const AnnotationGroupNode = ({
  group,
  isChecked,
  handleChange,
  isIndeterminate,
}: AnnotationGroupNodeProps) => {
  const checkboxRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  return (
    <div className={cn('flex justify-between items-center py-1 z-1')}>
      <div className={cn('flex items-center gap-2 text-neutral-600')}>
        <input
          checked={isChecked}
          onChange={handleChange}
          ref={checkboxRef}
          style={{
            accentColor: '#726F74',
          }}
          type="checkbox"
        />
        <p className={cn('typo-text-small text-neutral-800 whitespace-nowrap')}>{group.name}</p>
      </div>
    </div>
  );
};
